import styled from "styled-components";
import React from "react";

export const CheckBoxStyle = styled.input`
	width: auto;
	opacity: 0.00000001;
	position: absolute;
	left: 0;
	margin-left: -20px;

	&:checked ~ label {
		&:before {
			border: ${({ color, theme }) =>
				color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};
		}
		&:after {
			transform: rotate(-45deg) scale(1);
		}
	}
	&:focus + label::before {
		outline: 0;
	}
`;
export const CheckboxWrapper = styled.div`
	width: 100%;
	/* margin: 15px auto; */
	position: relative;
	display: block;
`;
export const CheckBoxLabel = styled.label`
	position: relative;
	min-height: 34px;
	display: block;
	padding-left: 40px;
	margin-bottom: 0;
	font-weight: normal;
	cursor: pointer;
	span {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	&:before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		margin: 4px;
		width: 22px;
		height: 22px;
		transition: transform 0.28s ease;
		border-radius: 3px;
		border: ${({ color, theme }) =>
			color ? `2px solid ${color}` : `2px solid ${theme.colors.grey}`};
	}
	&:after {
		content: "";
		display: block;
		width: 10px;
		height: 5px;
		border-bottom: ${({ color, theme }) =>
			color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};
		border-left: ${({ color, theme }) =>
			color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};
		transform: rotate(-45deg) scale(0);
		transition: transform ease 0.25s;
		position: absolute;
		top: 12px;
		left: 10px;
	}
`;
export const CheckBox = ({ color, size, register, label, name }) => {
	return (
		<CheckboxWrapper>
			<CheckBoxStyle
				color={color}
				ref={register}
				type="checkbox"
				id={name}
				name={name}
				value=""
			></CheckBoxStyle>
			<CheckBoxLabel color={color} size={size} htmlFor={name}>
				<span>{label}</span>
			</CheckBoxLabel>
		</CheckboxWrapper>
	);
};
